import { getString } from "../../common/common";

export const MH_TITLE1 = "MH_TITLE1";
export const MH_TITLE3 = "MH_TITLE3";
export const MH_TITLE4 = "MH_TITLE4";
export const MI_FAQ = "MI_FAQ";
export const MI_SITEMAP = "MI_SITEMAP";
export const MI_USER_MANUAL = "MI_USER_MANUAL";
export const MI_CONTACT_US = "MI_CONTACT_US";
export const MI_TIME_TABLE = "MI_TIME_TABLE";

export const MI_BOOK_BUS = "MI_BOOK_BUS";
export const MI_FR_LOGIN = "MI_FR_LOGIN";

export const translations = {
  en: {
    [MH_TITLE1]: "Related Links",
    [MH_TITLE3]: "Know More About",
    [MH_TITLE4]: "General Info",
    [MI_FAQ]: "FAQ",
    [MI_SITEMAP]: "Sitemap",
    [MI_USER_MANUAL]: "User Manual",
    [MI_CONTACT_US]: "Contact Us",
    [MI_TIME_TABLE]: "Time Table",
    [MI_BOOK_BUS]: "Book a Bus",
    [MI_FR_LOGIN]: "Operator / Franchisee Login",
  },
  kn: {
    [MH_TITLE1]: "ಸಂಬಂಧಿತ ಲಿಂಕ್‌ಗಳು",
    [MH_TITLE3]: "ಬಗ್ಗೆ ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    [MH_TITLE4]: "ಸಾಮಾನ್ಯ ಮಾಹಿತಿ",
    [MI_FAQ]: "ಆಗಾಗ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
    [MI_SITEMAP]: "ಸೈಟ್ ಮ್ಯಾಪ್",
    [MI_USER_MANUAL]: "ಬಳಕೆದಾರರ ಕೈಪಿಡಿ",
    [MI_CONTACT_US]: "ಸಂಪರ್ಕಿಸಿ",
    [MI_TIME_TABLE]: "ವೇಳಾ ಪಟ್ಟಿ",
    [MI_BOOK_BUS]: "ಬಸ್ ಕಾಯ್ದಿರಿಸಿ",
    [MI_FR_LOGIN]: "ಆಪರೇಟರ್ / ಫ್ರಾಂಚೈಸಿ ಲಾಗಿನ್",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
